import { Injectable } from '@angular/core';
import {
  AllOfficersByCustomerQuery,
  LookupOfficersForExpertQuery,
  OfficerFiltersInput,
  OfficerIdentificationTypesQuery,
  OfficerIdentificationTypeType,
  OfficerType,
} from '@generated/graphql';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OfficerService {
  constructor(
    private officerIdentificationTypes: OfficerIdentificationTypesQuery,
    private lookupOfficersForExpertQuery: LookupOfficersForExpertQuery,
    private allOfficersByCustomerQuery: AllOfficersByCustomerQuery,
  ) { }

  getIdentificationType() {
    return this.officerIdentificationTypes
      .fetch()
      .pipe(
        map(
          (res) =>
            res.data
              .officerIdentificationTypes as OfficerIdentificationTypeType[],
        ),
      );
  }

  lookupOfficersForExpert(filters: OfficerFiltersInput) {
    return this.lookupOfficersForExpertQuery
      .watch(
        {
          filters,
        },
        {
          fetchPolicy: 'no-cache',
        },
      )
      .valueChanges.pipe(
        map((res) => res.data.allOfficersForExpert as OfficerType[]),
      );
  }

  allOfficersByCustomer(country: string) {
    return this.allOfficersByCustomerQuery
      .fetch(
        {
          country,
        },
        {
          fetchPolicy: 'no-cache',
        },
      )
      .pipe(
        map(({ data }) => (data?.allOfficersByCustomer ?? []) as OfficerType[]),
      );
  }
}
